import React from 'react';

import { Avatar as AntAvatar } from 'antd';
import { GroupProps } from 'antd/lib/avatar/group';
import { AvatarSize } from 'antd/lib/avatar/SizeContext';

import cn from 'classnames';
import styles from './Group.module.scss';

export interface IAvatarGroupProps extends GroupProps {
  /** Max avatars to show */
  maxCount?: number;
  /** The style of excess avatar style */
  maxStyle?: React.CSSProperties;
  /** The placement of excess avatar Popover */
  maxPopoverPlacement?: 'top' | 'bottom';
  /** The size of the avatar */
  size?: AvatarSize;
}

/**
 * Avatar group display
 */
export const Group: React.FC<IAvatarGroupProps> = ({ className, ...props }) => (
  <AntAvatar.Group className={cn(styles.Group, className)} {...props} />
);
